import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DateInputComponent } from './components/dateInput/date-input.component';
import { FeederFilterComponent } from './components/feeder-filter/feeder-filter.component';
import { FeederLiveHeaderSelectorComponent } from './components/feeder-live-header-selector/feeder-live-header-selector.component';
import { FeederQueryParamsComponent } from './components/feeder-query-params/feeder-query-params.component';
import { FeederSearchComponent } from './components/feeder-search/feeder-search.component';
import { FeederSelectComponent } from './components/feeder-select/feeder-select.component';
import { FeederComponent } from './components/feeder/feeder.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { QueryPeriodComponent } from './components/query-period/query-period.component';
import { TimestampComponent } from './components/timestamp/timestamp.component';
import { MyHttpInterceptor } from './interceptors/http.interceptor';
import { ApiService } from './services/api.service';
import { ExcelService } from './services/excel.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './modules/material.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MenuService } from './services/menu.service';
import { IndexedDBService } from './services/indexeddb.service';

@NgModule({
  declarations: [
    AppComponent,
    FeederComponent,
    TimestampComponent,
    HeaderComponent,
    FooterComponent,
    DateInputComponent,
    FeederSearchComponent,
    FeederSelectComponent,
    FeederFilterComponent,
    FeederQueryParamsComponent,
    QueryPeriodComponent,
    FeederLiveHeaderSelectorComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    MatTooltipModule,
  ],
  providers: [
    ApiService,
    ExcelService,
    MenuService,
    IndexedDBService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyHttpInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
